import React from 'react';

// import Sketch from './Sketch/Sketch';
// import { ScaleTest } from './Sketch/scales';
// import Growth from './Growth/Growth';
import Lines from './Lines/Lines';

const App = () => (
  <div>
    <Lines width={300} height={400} />
    {/*
    <Lines width={1350} height={752} />
    <ScaleTest width={500} height={300} cutIn={[0, 0.1]} cutOut={[0.6, 1]} />
    */}
    {/*
    <Sketch
      width={1000}
      height={700}
      count={60}
      cutIn={[0.01, 0.05]}
      cutOut={[0.075, 0.15]}
    />
    <Sketch
      width={300}
      height={700}
      count={60}
      cutIn={[0.01, 0.05]}
      cutOut={[0.075, 0.15]}
    />
    */}
    {/*
    <Sketch width={200} height={700} count={20} />
    <Sketch width={760} height={760} count={60} />
    */}
  </div>
);

export default App;



// WEBPACK FOOTER //
// ./components/App.jsx